export const getArticleImages = (images) => {
  if (Array.isArray(images)) {
    return images;
  }
  if (typeof images !== 'string') {
    return [];
  }
  try {
    const parsed = JSON.parse(images);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getFailedArticleImages = (images) =>
  getArticleImages(images).filter((image) => image?.status === 'failure');

export const getArticleImageSummary = (images) =>
  getArticleImages(images).reduce(
    (summary, image) => ({
      ...summary,
      failed: summary.failed + (image?.status === 'failure' ? 1 : 0),
      generating: summary.generating + (image?.status === 'generating' ? 1 : 0),
      pending: summary.pending + (!image?.status || image.status === 'pending' ? 1 : 0),
      successful: summary.successful + (image?.status === 'success' ? 1 : 0),
      total: summary.total + 1,
    }),
    {
      failed: 0,
      generating: 0,
      pending: 0,
      successful: 0,
      total: 0,
    },
  );

const normalizeImagePath = (path) =>
  String(path)
    .replace(/^oss:\/\//i, '')
    .replace(/^\/+/, '');

export const rehypeArticleImages = ({ images }) => {
  const imageMap = new Map(
    getArticleImages(images)
      .filter((image) => image?.path)
      .map((image) => [normalizeImagePath(image.path), image]),
  );
  const transform = (node) => {
    if (node.tagName === 'img') {
      const { src, alt } = node.properties;
      const image = imageMap.get(normalizeImagePath(src));
      if (image?.status === 'success' && image.url) {
        return { ...node, properties: { ...node.properties, src: image.url } };
      }
      if (image || /^oss:\/\//i.test(src)) {
        const label = { failure: '生成失败', generating: '生成中' }[image?.status] || '等待生成';
        return { type: 'text', value: `${alt || '配图'}（${label}）` };
      }
    }
    if (node.children) {
      return { ...node, children: node.children.map(transform) };
    }
    return node;
  };
  return transform;
};
